import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { Certification, CacheService, ITypeCertificationBO } from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class CertificationService {

  className = 'CertificationService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllCertifications(cache = true, cacheKey = "allCertifications"): Observable<ITypeCertificationBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeCertificationBO[]>;
    } else {
      const observable = this.http.get<ITypeCertificationBO[]>(environment.base_URL + "/types-certifications").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newCertification(certification: ITypeCertificationBO): Observable<ITypeCertificationBO[]> {
    return this.http.post<ITypeCertificationBO[]>(environment.base_URL + "/types-certifications", certification).pipe(tap(() => this.deleteCache()))
  }

  updateCertification(certification: ITypeCertificationBO, id: number): Observable<ITypeCertificationBO[]> {
    return this.http.put<ITypeCertificationBO[]>(environment.base_URL + `/types-certifications/${id}`, certification).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    this.cacheService.deleteCache('allCertifications');
  }
}

